// extracted by mini-css-extract-plugin
export var addButton = "_b5-0";
export var border = "_b5-8";
export var check = "_b5-h";
export var danger = "_b5-6";
export var dropdownContainer = "_b5-1";
export var editModalBody = "_b5-j";
export var footerContainer = "_b5-i";
export var fullWidth = "_b5-a";
export var hide = "_b5-9";
export var icon = "_b5-3";
export var input = "_b5-7";
export var inputFlex = "_b5-b";
export var inputWrapper = "_b5-c";
export var manualFocus = "_b5-5";
export var optionButton = "_b5-4";
export var pillWrapper = "_b5-e";
export var pointer = "_b5-2";
export var showOverflow = "_b5-f";
export var tagsFlex = "_b5-d";
export var xButton = "_b5-g";